// extracted by mini-css-extract-plugin
export default {"teachers":"TeachersDetail_teachers__zaKlX","h1":"TeachersDetail_h1__ND9UH","logout-btn":"TeachersDetail_logout-btn__higqi"};